import { render, staticRenderFns } from "./AuctionLocation.vue?vue&type=template&id=388e269e&scoped=true&"
import script from "./AuctionLocation.vue?vue&type=script&lang=js&"
export * from "./AuctionLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e269e",
  null
  
)

export default component.exports